module.exports = __webpack_public_path__ + "static/chemical-synthesis-acceptance-tests-fb9724e3472963d1af8fe68f46d5efe2.pdf";